module.exports = __webpack_public_path__ + "img/wellness.0b8636d4.svg";